import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { StopWatch } from 'components/StopWatch';
import { alertActions, user_profileActions } from '../../../../../actions';
import { BasicSpinner } from '../../../../../components';
import { StatisticsContainer } from './StatisticsContainer';
import { statisticsErrorMessage } from './statisticsError';

const EMPTY_SUMMARY = {
  average_time_per_card_ms: 0,
  total_time_spent_ms: 0,
  time_tracked_cards_count: 0,
};
const EMPTY_WORKSPACE_IDS = [];
const EMPTY_ORGANIZATION_IDS = [];

function TimeCard({ modifier, label, timeMs }) {
  return (
    <div className={`statistics-card statistics-card--${modifier}`}>
      <div className="statistics-card__label">{label}</div>
      <div className="statistics-card__value">
        <StopWatch initialTime={timeMs} isActive={false} className="statistics-card__timer" />
      </div>
    </div>
  );
}

function CountCard({ modifier, label, count }) {
  return (
    <div className={`statistics-card statistics-card--${modifier}`}>
      <div className="statistics-card__label">{label}</div>
      <div className="statistics-card__value">{count}</div>
    </div>
  );
}

function ProductivitySummary({
  userId,
  range,
  excludedWorkspaceIds = EMPTY_WORKSPACE_IDS,
  excludedOrganizationIds = EMPTY_ORGANIZATION_IDS,
}) {
  const dispatch = useDispatch();
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    user_profileActions
      .fetchProductivitySummary(userId, range, excludedWorkspaceIds, excludedOrganizationIds)
      .then((data) => {
        if (!isMounted) return;

        if (data && data.status === 'ok') {
          setSummary({
            average_time_per_card_ms: data.average_time_per_card_ms,
            total_time_spent_ms: data.total_time_spent_ms,
            time_tracked_cards_count: data.time_tracked_cards_count,
          });
        }
      })
      // Without this a rejected range (400) or a throttle (429) is indistinguishable
      // from a range with no tracked time: zeroed cards and no explanation.
      .catch((error) => {
        if (!isMounted) return;

        setSummary(EMPTY_SUMMARY);
        dispatch(alertActions.error(statisticsErrorMessage(error)));
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
    // excludedWorkspaceIds / excludedOrganizationIds are tracked via their joined keys.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, range, excludedWorkspaceIds.join(','), excludedOrganizationIds.join(',')]);

  return (
    <>
      <h2>Overview</h2>
      {loading ? (
        <div className="d-flex justify-content-center py-4">
          <BasicSpinner />
        </div>
      ) : (
        <div className="user_profile-statistics-productivity-summary">
          <TimeCard
            modifier="blue"
            label="Average Time Per Card"
            timeMs={summary.average_time_per_card_ms}
          />
          <TimeCard
            modifier="yellow"
            label="Total Time Spent"
            timeMs={summary.total_time_spent_ms}
          />
          <CountCard
            modifier="red"
            label="Number of Cards Time Tracked"
            count={summary.time_tracked_cards_count}
          />
        </div>
      )}
    </>
  );
}

export default ProductivitySummary;
